export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6956.a4b55655.jpg";